export const initialCreateAgentPayload = {
    voice_agent_name: "",
    voice_agent_description: "",
    voice_agent_detail: {
        voice_agent_detail_prompt: "",
        voice_agent_model_id: "",
        language_id: null,
        ai_agent_voice_id: ""
    },
    voice_agent_field_data: []
}

export const getDefaultLanguageAndVoice = (languageList, aiAgentVoices) => {
    const defaultLanguage = languageList?.find(
        (language) => language?.name?.toLowerCase() === 'english'
    );
    const defaultVoice = aiAgentVoices?.find(
        (voice) =>
            voice?.ai_agent_voice_name?.toLowerCase() === 'adam' &&
            voice?.ai_agent_voice_gender?.toLowerCase() === 'male'
    );

    return {
        language_id: defaultLanguage?.language_id ?? null,
        ai_agent_voice_id: defaultVoice?.ai_agent_voice_id ?? '',
    };
};

export const VOICE_AGENT_FIELDS_KEY = {
    USER_SPEAKS_FIRST: "user_speaks_first",
    WELCOME_MESSAGE: "welcome_message",
    INTERRUPTION_SENSITIVITY: "interruption_sensitivity",
    RESPONSE_EAGERNES: "response_eagerness",
    MAX_CALL_DURATION_SEC: "max_call_duration_sec",
}

export const voiceAgentFieldDisplayOrder = [
    VOICE_AGENT_FIELDS_KEY.USER_SPEAKS_FIRST,
    VOICE_AGENT_FIELDS_KEY.WELCOME_MESSAGE,
    VOICE_AGENT_FIELDS_KEY.INTERRUPTION_SENSITIVITY,
    VOICE_AGENT_FIELDS_KEY.RESPONSE_EAGERNES,
    VOICE_AGENT_FIELDS_KEY.MAX_CALL_DURATION_SEC,
]

export const userSpeaksFirstOptions = [
    { label: "User Speaks First", value: "true" },
    { label: "AI Speaks First", value: "false" },
]

export const buildDefaultVoiceAgentFieldData = (fields) => {
    if (!fields?.length) return [];
    return fields.map((field) => ({
        ...field,
        voice_agent_field_data_id: null,
        voice_agent_field_data_value: field.voice_agent_field_default_value,
    }));
};

export const sortVoiceAgentFieldsByDisplayOrder = (fields) => {
    if (!fields?.length) return [];
    return [...fields].sort((a, b) => {
        const aIndex = voiceAgentFieldDisplayOrder.indexOf(a.voice_agent_field_key);
        const bIndex = voiceAgentFieldDisplayOrder.indexOf(b.voice_agent_field_key);
        const orderedA = aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex;
        const orderedB = bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex;
        return orderedA - orderedB;
    });
};